import React from "react";

export default function Button({
  title,
  className,
  onClick,
  variant,
  type,
  disabled,
  loading,
  buttonLink,
}) {
  variant ??= "primary";
  type ??= "button";
  const classes = ["button", "button--" + variant];

  if (className) {
    classes.push(className);
  }

  if (loading) {
    classes.push("loading");
  }

  return (
    <>
      {buttonLink ? (
        <a href={buttonLink} className={classes.join(" ")} aria-label={title}>
          {loading && <Spinner />}

          <span className="button__text">{title}</span>
        </a>
      ) : (
        <button
          aria-label={title}
          className={classes.join(" ")}
          type={type}
          onClick={onClick}
          disabled={disabled || loading}
        >
          {loading && <Spinner />}
          <span className="button__text">{title}</span>
        </button>
      )}
    </>
  );
}

const Spinner = () => (
  <div className="loading-overlay__spinner">
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      className="spinner"
      viewBox="0 0 68 68"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className="path"
        fill="none"
        strokeWidth="8"
        cx="34"
        cy="34"
        r="30"
      ></circle>
    </svg>
  </div>
);
